import React from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";

import {GroheLockIcon} from "../../../../common/icons";


const LookFeatureItemLocked = (props) => {

  const {type} = props;

  return (
    <div className={"lm-feature__unlock " + (type ? "lm-feature__unlock--" + type : "")}>
      <div className="lm-feature__unlock-icon">
        <SvgIcon fontSize={"inherit"}>
          <GroheLockIcon className="lm-locked__icon"/>
        </SvgIcon>
      </div>
      <div className="lm-feature__unlock-text">
        <FormattedMessage id={type === "small" ? "look.features.itemLocked.small" : "look.features.itemLocked"}/>
      </div>
    </div>
  )
};

LookFeatureItemLocked.propTypes = {
  type: PropTypes.string
}

export default LookFeatureItemLocked
